import React, { useState } from "react";
import { TableRow, TableCell } from "@material-ui/core";
import {
  IconButtonDatatable,
  MasterButton,
  ModalDeleteConfirm,
  TableCellDefault,
} from "App/Component/ui";
import {
  downloadPDF,
  STATUS_BARANG_PENDING,
  STATUS_BARANG_PENGAJUAN,
  STATUS_BARANG_PROSES,
  STATUS_BARANG_SELESAI,
  STATUS_PENGERJAAN_DRAFT,
} from "../helpers";
import { instance4 } from "App/constants";
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { DownloadIcon, PencilIcon, SelectIcon, TrashIcon } from "App/Assets";
import { FreezeTableClient } from "components/organism";

export const USER = localStorage.getItem("user_name");
export const urlUpload = "/wmsAsset/request/upload_tor";

export default function ListDetail({
  setNewDataReqList,
  formData,
  listDetail,
  actSelect = false,
  handleSelect,
}) {
  const [downloadId, setdownloadId] = useState("");
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [showModalVerifikasi, setShowModalVerifikasi] = useState(false);
  // const [formVerifikasi, setFormVerifikasi] = useState({
  //   id: "",
  //   fixasset_id: "",
  //   nama_asset: "",
  //   remark: "",
  //   keterangan_cek_barang: "",
  // });

  function handleVerifikasi(row) {
    setdownloadId(row);
    // setFormVerifikasi({
    //   id: row?.id,
    //   fixasset_id: row?.remark_status,
    //   nama_asset: row?.nama_asset,
    //   remark: row?.remark,
    //   keterangan_cek_barang: row?.remark_status,
    // });
    setShowModalVerifikasi(!showModalVerifikasi);
  }

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listDetail,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const headCells = [
    {
      id: "no",
      disablePadding: false,
      label: "NO",
      align: "center",
      sort: false,
      maxWidth: "80px",
    },
    {
      id: "act",
      disablePadding: false,
      label: "ACTION",
      align: "left",
      sort: false,
    },
    {
      id: "id",
      disablePadding: false,
      label: "ID",
      align: "center",
      sort: true,
      maxWidth: "80px",
    },
    {
      id: "name",
      disablePadding: false,
      label: "NAMA ASSET",
      align: "left",
      sort: true,
      minWidth: "200px",
    },
    {
      id: "code_asset",
      disablePadding: false,
      label: "CODE ASSET",
      align: "left",
      sort: true,
      minWidth: "150px",
    },
    {
      id: "remark",
      disablePadding: false,
      label: "CATATAN",
      align: "left",
      sort: true,
      minWidth: "200px",
    },
    {
      id: "file_name",
      disablePadding: false,
      label: "FILE",
      align: "left",
      sort: false,
      minWidth: "180px",
    },
    {
      id: "status_request",
      disablePadding: false,
      label: "STATUS",
      align: "left",
      sort: false,
      minWidth: "180px",
    },
    {
      id: "remark_status",
      disablePadding: false,
      label: "CATATAN PEMERIKSAAN",
      align: "left",
      sort: false,
      minWidth: "200px",
    },
    {
      id: "no_faktur",
      disablePadding: false,
      label: "NO. FAKTUR",
      align: "left",
      sort: false,
      minWidth: "150px",
    },
    {
      id: "user_approve",
      disablePadding: false,
      label: "USER VERIFIKASI",
      align: "left",
      sort: false,
      minWidth: "150px",
    },
    {
      id: "taggal_approve",
      disablePadding: false,
      label: "TANGGAL VERIFIKASI",
      align: "left",
      sort: false,
      minWidth: "180px",
    },
    {
      id: "createdAt",
      disablePadding: false,
      label: "INSERTED TIME",
      sort: false,
      minWidth: "170px",
    },
    {
      id: "createdBy",
      disablePadding: false,
      label: "INSERTED BY",
      sort: false,
      minWidth: "150px",
    },
    {
      id: "updatedAt",
      disablePadding: false,
      label: "UPDATED TIME",
      sort: false,
      minWidth: "170px",
    },
    {
      id: "updatedBy",
      disablePadding: false,
      label: "UPDATED BY",
      sort: false,
      minWidth: "150px",
    },
  ];

  const deleteById = async (id) => {
    try {
      const api = await instance4.post("/wmsAsset/helpdesk/delete-detail", {
        id,
      });
      const res = api.data;
      if (res.status === 200) {
        return {
          state: true,
          message: res?.message,
        };
      } else {
        return {
          state: false,
          message: res?.message,
        };
      }
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      };
    }
  };

  async function deleteList() {
    const res = await deleteById(downloadId);

    if (res.state) {
      defaultToastSuccess("Berhasil Menghapus Data !");
      await setNewDataReqList(formData.id);
    } else {
      defaultToastError(res.message);
    }
    setShowModalDeleteConfirm(false);
  }

  function handleClickDelete(row) {
    setdownloadId(row);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  const RenderStatusVerifikasiBadge = ({ status }) => {
    // eslint-disable-line
    if (status === STATUS_BARANG_PENGAJUAN) {
      return (
        <MasterButton
          style={{ borderRadius: 20 }}
          name={"PENGAJUAN"}
          color={"secondary"}
          type='button'
          disabled
        />
      );
    } else if (status === STATUS_BARANG_PROSES) {
      return (
        <MasterButton
          style={{ borderRadius: 20 }}
          name={"PROSES"}
          color={"lightgreen"}
          type='button'
          disabled
        />
      );
    } else if (status === STATUS_BARANG_SELESAI) {
      return (
        <MasterButton
          style={{ borderRadius: 20 }}
          name={"SELESAI"}
          color={"green"}
          type='button'
          disabled
        />
      );
    } else if (status === STATUS_BARANG_PENDING) {
      return (
        <MasterButton
          style={{ borderRadius: 20 }}
          name={"PENDING"}
          color={"warning"}
          type='button'
          disabled
        />
      );
    } else {
      return <p>-</p>;
    }
  };

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {/* {showModalVerifikasi && (
        <ModalVerifikasi
          formData={formData}
          formVerifikasi={formVerifikasi}
          setFormVerifikasi={setFormVerifikasi}
          setNewDataReqList={setNewDataReqList}
          setShowModalVerifikasi={() => setShowModalVerifikasi(false)}
        />
      )} */}

      <FreezeTableClient
        title='List Permintaan'
        setQ={setQ}
        maxHeight='300px'
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={listDetail}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                // style={{
                //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                // }}
              >
                <TableCell scope='row' padding='none' align='center'>
                  {index + 1}.
                </TableCell>

                <TableCell scope='row' padding='none' align='center'>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "7px",
                    }}>
                    {!isNull(row?.file_name) && (
                      <IconButtonDatatable
                        onClick={() => downloadPDF(row.id, row.file_name)}>
                        <DownloadIcon />
                      </IconButtonDatatable>
                    )}
                    {formData?.status_request === STATUS_PENGERJAAN_DRAFT ? (
                      <IconButtonDatatable
                        onClick={() => handleClickDelete(row.id)}>
                        <TrashIcon />
                      </IconButtonDatatable>
                    ) : (
                      <></>
                    )}
                    {actSelect && row?.status_request !== null ? (
                      <IconButtonDatatable onClick={() => handleSelect(row)}>
                        <SelectIcon />
                      </IconButtonDatatable>
                    ) : (
                      <></>
                    )}
                    {actSelect && row?.status_request === null ? (
                      <IconButtonDatatable
                        onClick={() => handleVerifikasi(row)}>
                        <PencilIcon />
                      </IconButtonDatatable>
                    ) : (
                      <></>
                    )}
                  </div>
                </TableCell>
                <TableCell align='center'>{row?.id}</TableCell>
                <TableCell align='left'>{row?.nama_asset}</TableCell>
                <TableCell align='left'>{row?.code_asset}</TableCell>
                <TableCell align='left'>
                  {isNull(row?.remark) ? "-" : row?.remark}
                </TableCell>
                <TableCell align='left'>{row?.file_name}</TableCell>
                <TableCell align='left'>
                  <RenderStatusVerifikasiBadge status={row?.status_request} />
                </TableCell>
                <TableCell align='left'>
                  {isNull(row?.remark_status) ? "-" : row?.remark_status}
                </TableCell>
                <TableCell align='left'>
                  {isNull(row?.no_faktur) ? "-" : row?.no_faktur}
                </TableCell>
                <TableCell align='left'>
                  {isNull(row?.user_approve) ? "-" : row?.user_approve}
                </TableCell>
                <TableCell align='left'>
                  {isNull(row?.taggal_approve)
                    ? "-"
                    : defaultDateDisplay(row?.taggal_approve)}
                </TableCell>
                <TableCellDefault row={row} type={"default"} />
              </TableRow>
            );
          })}
      </FreezeTableClient>
    </>
  );
}
